import 'twin.macro'

import DropDownBlock from 'components/UI/drop-down-block'
import Title from 'components/UI/title/title'
import { questionsKk } from 'i18n/locales/kk/landing-faq'
import { questionsRu } from 'i18n/locales/ru/landing-faq'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
function Faq() {
  const [questions, setQuestions] = useState<{ a: string; q: string }[]>()
  const { t, i18n } = useTranslation()
  useEffect(() => {
    i18n.language === 'ru' ? setQuestions(questionsRu) : setQuestions(questionsKk)
  }, [t])

  return (
    <div tw='sm:text-[48px] text-[32px] font-bold'>
      <p>{t('faq.title', { ns: 'landing' })}</p>
      <div tw='flex flex-col gap-5 mt-5'>
        {questions?.map((item, idx) => (
          <DropDownBlock data={item} key={`question-block-${idx + 1}`} />
        ))}
      </div>
    </div>
  )
}

export default Faq
